<template>
  <div>
    <ds-heading text="Tabela do IRRF" />

    <ds-row>
      <ds-col size="2">
        <ds-button full-width @click="onPrevious">Anterior</ds-button>
      </ds-col>
      <ds-col size="8">
        <ds-heading
          :text="`Válido de ${irrf.dtInicio} até ${irrf.dtFim}`"
          size="sm"
          class="ds-u-text-align--center">
          /
        </ds-heading>
      </ds-col>
      <ds-col
        size="2"
        align="right">
        <ds-button full-width @click="onNext">Próxima</ds-button>
      </ds-col>
    </ds-row>

    <ds-page>
      <ds-async-content-wrapper
        :fetch-action="getIrrf"
        @fetch-success="setIrrf">
        <ds-row>
          <ds-col size="10" offset="1">
            <ds-row>
              <ds-col size="3" class="ds-u-text-align--right">
                <ds-heading size="sm" text="Rendimentos Até R$:" />
              </ds-col>
              <ds-col size="5" class="ds-u-text-align--center">
                <ds-heading size="sm" text="Alíquota(%):" />
              </ds-col>
              <ds-col size="3">
                <ds-heading size="sm" text="Dedução R$:" />
              </ds-col>
            </ds-row>
            <ds-row
              v-for="(item, index) in viewInfo"
              :key="index">
              <ds-col size="3" class="ds-u-text-align--right">
                {{ item.incomeUpTo }}
              </ds-col>
              <ds-col size="1" class="ds-u-text-align--center">
                <ds-icon size="sm" icon="arrow-right" />
              </ds-col>
              <ds-col size="3" class="ds-u-text-align--center">
                {{ item.aliquot }}
              </ds-col>
              <ds-col size="1" class="ds-u-text-align--center">
                <ds-icon size="sm" icon="minus" />
              </ds-col>
              <ds-col size="3">
                {{ item.deduction }}
              </ds-col>
            </ds-row>
            <hr />
            <ds-row>
              <ds-col
                offset="3"
                size="4"
                class="ds-u-text-align--right">
                <ds-heading size="sm" text="Dedução por dependente" />
              </ds-col>
              <ds-col size="1" class="ds-u-text-align--center">
                <ds-icon size="sm" icon="minus" />
              </ds-col>
              <ds-col size="3">
                {{ irrf.deduDepen | caCurrency }}
              </ds-col>
            </ds-row>
            <ds-row v-if="shouldShowSimplifiedDiscount">
              <ds-col
                offset="3"
                size="4"
                class="ds-u-text-align--right">
                <ds-heading size="sm" text="Desconto simplificado" />
              </ds-col>
              <ds-col size="1" class="ds-u-text-align--center">
                <ds-icon size="sm" icon="minus" />
              </ds-col>
              <ds-col size="3">
                {{ irrf.simplifiedDiscount | caCurrency }}
              </ds-col>
            </ds-row>
          </ds-col>
        </ds-row>
      </ds-async-content-wrapper>
    </ds-page>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import {
  getLatestIrrf, mountViewInfo, getPreviousIrrf, getNextIrrf,
} from './irrfService';

library.add(faArrowRight);

export default {
  name: 'IRRFPage',
  data() {
    return {
      irrf: { dtInicio: '', dtFim: '' },
      viewInfo: [],
    };
  },
  computed: {
    shouldShowSimplifiedDiscount() {
      return this.irrf.simplifiedDiscount !== 0;
    },
  },
  methods: {
    getIrrf() {
      return getLatestIrrf();
    },
    setIrrf(response) {
      this.irrf = response;
      this.viewInfo = mountViewInfo(this.irrf);
    },
    mountViewInfo,
    onPrevious() {
      getPreviousIrrf(this.irrf.id)
        .then(response => {
          if (!response) {
            this.$toaster.warning('Não existe tabela anterior');
          } else {
            this.setIrrf(response);
          }
        })
        .catch(() => {
          this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
        });
    },
    onNext() {
      getNextIrrf(this.irrf.id)
        .then(response => {
          if (!response) {
            this.$toaster.warning('Não existe tabela posterior');
          } else {
            this.setIrrf(response);
          }
        })
        .catch(() => {
          this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
        });
    },
  },
};
</script>
